import CONFIG from '@/config/config'
class UrlService {

  urlAlleAnwendungen(): string {
    return CONFIG.anwendungslisteLink;
  }

}

const urlService = new UrlService()
export default urlService
